import { Box, Text, Link, Center } from "@chakra-ui/react";

const Footer = () => {
  return (
    <Box
      position={"relative"}
      h={{ base: "10rem", md: "23rem" }}
      as="footer"
      bg="neutral.950"
      color="white"
      overflow={"hidden"}
      px={8}
      width="100%"
    >
      <Text mt={2} fontSize="lg" textAlign="center">
        For inquiries or support, reach out to us at:{" "}
        <Link href="mailto:support@bellu.ai" color="yellow.300">
          support@bellu.ai
        </Link>
      </Text>
      <Center>
        <Text
          position={"absolute"}
          bottom={{ base: "-1.6rem", md: "-6.7rem" }}
          fontWeight="bold"
          fontSize={{ base: "5rem", md: "20rem" }}
          color={"neutral.900"}
          textAlign="center"
        >
          Bellu.ai
        </Text>
      </Center>
    </Box>
  );
};

export default Footer;
